<template>
  <div class="intro-pratice-content" id="identidade-verbal-na-pratica-introducao" data-search-anchor>
    <div class="intro-pratice-title-content">
      <h1 class="intro-pratice-title">{{ introTitle }}</h1>
      <p class="intro-pratice-paragraph">{{ introParagraph }}</p>
    </div>

    <div
      class="intro-pratice-card-item"
      :style="{ backgroundImage: `url(${introImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PraticePageMixin from '@/mixins/pratice-page-mixin'
import { PraticePageStore } from '@/store/verbal-identity-page/pratice-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PraticeIntroSection extends Mixins(PraticePageMixin) {
  praticePageStore: PageStoreContract = getModule(PraticePageStore, this.$store)

  get introTitle(): string {
    return this.getElementTitle(1, 0)
  } 

  get introImageSrc(): string {
    return this.getElementMedia(1, 0)
  }

   async getPraticePage(): Promise<void> {
    await this.praticePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.praticePageStore.isLoading) {
      await this.getPraticePage()
    }
  }
}
</script>

<style lang="scss">
.intro-pratice-content {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  max-width: 1032px;  
}

.intro-pratice-title {
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
  padding-right: 23px;
}

.intro-pratice-paragraph {
  margin-top: 47px;
  width: 363px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left; 
} 

.intro-pratice-card-item {
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;
}

</style>

